import React from 'react'
import FollowerCardInline from '../follower-card-inline'
import { Methods } from '../../../../core/utility';
import { Skeleton } from '@mui/material';

type Props = {
    influencerData: any;
    className?:string;
    loading?:boolean;

}
const methods = new Methods();

const PostFrequency = ({ influencerData, className, loading }: Props) => {
    return (
        // <>{loading || (influencerData?.detail?.[0]?.post_frequency > 0 || influencerData?.detail?.[0]?.average_profile_views > 0 || influencerData?.detail?.[0]?.total_impressions > 0) &&
        <div className={`follower-sec-inline ${className}`}>
            {(loading || influencerData?.detail?.[0]?.post_frequency > 0) &&
            <FollowerCardInline title="Post Frequency" value={loading ? <Skeleton /> :  influencerData?.detail?.[0]?.post_frequency
                && `${methods.convertNumber(influencerData.detail[0].post_frequency)}/week`
                } />
            }
            {(loading || influencerData?.detail?.[0]?.average_profile_views > 0) &&
                <FollowerCardInline className="d-none d-md-flex" title="Avg. Profile Views" value={loading ? <Skeleton /> :`${methods.convertNumber(influencerData?.detail?.[0]?.average_profile_views)}/day`} />
            }
            {(loading || influencerData?.detail?.[0]?.total_impressions > 0) &&
                <FollowerCardInline tooltip tooltipText="Total number of times the IG User's IG Media have been viewed. Includes ad activity generated through the API, Facebook ads interfaces, and the Promote feature. Does not include profile views." title="Impressions" value={loading ? <Skeleton /> : methods.convertNumber(influencerData?.detail?.[0]?.total_impressions)} />
            }
        
        </div>
        // }</>
    )
}

export default PostFrequency

